// extracted by mini-css-extract-plugin
export var AuthorAvatarContainer = "bl_dx";
export var AuthorBioContainer = "bl_dv";
export var AuthorContainer = "bl_dt";
export var AuthorGradientBackground = "bl_dw";
export var AuthorInfoContainer = "bl_dy";
export var AuthorInfoDetails = "bl_dz";
export var AuthorInfoName = "bl_dB";
export var AuthorInfoSection = "bl_dC";
export var MuiPopperRoot = "bl_bP";
export var MuiTooltipPopper = "bl_bQ";